module.exports = __webpack_public_path__ + "img/gestion_financiera.932fe0ea.jpeg";